import { inject, observer } from "mobx-react";
import { Tab, Tabs } from "react-bootstrap";

import applicationRouter from "../../../hoc/applicationRouter";
import withLocalization from "../../../hoc/withLocalization";

import HolidayRecommendationModal from "../../../components/HolidaySettings/HolidayRecommendationModal";
import NotificationManagement from "./NotificationManagement";

const ModuleSettings = ({ t }) => {
    return (
        <div className="control-panel">
            <Tabs defaultActiveKey="holiday" id="ModuleSettingsTabs">
                <Tab eventKey="holiday" title={t('Holiday Settings')}>
                    <HolidayRecommendationModal />
                </Tab>
                <Tab eventKey="notifications" title={<>{t('Notification')} {t('Management')}</>} mountOnEnter>
                    <NotificationManagement />
                </Tab>
            </Tabs>
        </div>
    );
};
export default inject('clientStore', 'commonStore')(applicationRouter(withLocalization(observer(ModuleSettings))));
